import { render, staticRenderFns } from "./DocsGPTIcon.vue?vue&type=template&id=12dffaa6&scoped=true"
import script from "./DocsGPTIcon.vue?vue&type=script&lang=js"
export * from "./DocsGPTIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dffaa6",
  null
  
)

export default component.exports